import { csx } from '@vtex/admin-ui'

const styles = {
  container: csx({
    width: '560px',
    maxWidth: '100%',
    '& footer': {
      justifyContent: 'flex-end',
    },
    '& button': {
      width: 'fit-content',
    },
  }),
}

export default styles
